import React from 'react'
import SwipeableViews from 'react-swipeable-views'
import { mod } from 'react-swipeable-views-core'
import { autoPlay, bindKeyboard, virtualize } from 'react-swipeable-views-utils'
import { array, bool, number } from 'prop-types'
import Image from '../Image'
import styled from 'styled-components'
import media from '../../utils/style'
import IconFormArrowRight from '../../vectors/IconFormArrowRight'
import Pagination from './components/Pagination'

const CarouselWrapper = styled.div`
  position: relative;
`
const IconFormArrowLeft = styled(IconFormArrowRight)`
  transform: rotate(180deg);
`

const ButtonNext = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 0;
  width: 45px;
  height: 45px;
  background-color: rgba(0, 0, 0, 0.1);
  color: #fff;
  transform: translateY(-50%);
  cursor: pointer;
  & svg {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 10;
  }

  ${media.MediumScreenUp`
    height: 90px;
    width: 90px;
    svg {
      width: 25px;
      height: 25px;
    }
  `}
`

const ButtonPrevious = styled(ButtonNext)`
  left: 0;
`

const SlideLink = styled.a`
  img {
    display: block;
    margin-bottom: 0;
    width: 100%;
  }
`
class Slide extends React.PureComponent {
  // `onClick` and `onMouseDown` are used to allow mouse-dragging of the
  // carousel, without triggering the href of the anchor.

  constructor() {
    super()
    this._handleMouseDown = this._handleMouseDown.bind(this)
    this._handleClick = this._handleClick.bind(this)
  }

  _handleMouseDown(e) {
    // store mouse position when click starts
    this.x = e.screenX
  }

  _handleClick(e) {
    const delta = Math.abs(e.screenX - this.x)
    if (delta > 10) {
      // If mouse moved more than threshold, ignore the click event
      e.preventDefault()
    }
    this.x = 0
  }

  render() {
    const { path, image, alt } = this.props
    return (
      <SlideLink
        onMouseDown={this._handleMouseDown}
        onClick={this._handleClick}
        href={path}
      >
        <Image resource={image} width="2500" alt={alt} />
      </SlideLink>
    )
  }
}

class ContentBrandHeroCarousel extends React.PureComponent {
  constructor(_props) {
    super(_props)
    this.state = {
      slides: this.props.slides,
      index: 0,
      autoplay: this.props.autoplay
    }
    this._slideRenderer = this._slideRenderer.bind(this)
    this._handleIndexChange = this._handleIndexChange.bind(this)
    this._handleClickNext = this._handleClickNext.bind(this)
    this._handleClickPrevious = this._handleClickPrevious.bind(this)
    this._handleClickSlideChange = this._handleClickSlideChange.bind(this)
  }

  _slideRenderer(params) {
    const { index, key } = params
    const _loopingIndex = mod(index, this.state.slides.length)
    const data = this.state.slides[_loopingIndex]
    return data && <Slide key={`cbhc:${data.path}:${key}:${index}`} {...data} />
  }

  _handleIndexChange(index) {
    this.setState({ index: index })
  }

  _handleClickNext(e) {
    e.preventDefault()
    this.setState({ index: this.state.index + 1, autoplay: false })
  }

  _handleClickPrevious(e) {
    e.preventDefault()
    this.setState({ index: this.state.index - 1, autoplay: false })
  }

  _handleClickSlideChange(e) {
    e.preventDefault()
    const selectedSlide = Number(e.target.getAttribute('data-slide-index'))
    this.setState({ index: selectedSlide, autoplay: false })
  }

  render() {
    if (this.props.slides.length === 1)
      return <Slide {...this.props.slides[0]} />

    if (this.props.slides.length === 0) return null

    const VirtualizedSwipeableViews = virtualize(SwipeableViews)
    const AutoPlaySwipeableViews = autoPlay(VirtualizedSwipeableViews)
    const BindKeyboardSwipeableViews = bindKeyboard(AutoPlaySwipeableViews)
    const EnhancedSwipeableViews = BindKeyboardSwipeableViews
    const currentSlideIndex = mod(this.state.index, this.state.slides.length)

    return (
      <CarouselWrapper>
        {this.props.controls && (
          <>
            <ButtonNext onClick={this._handleClickNext}>
              <IconFormArrowRight />
            </ButtonNext>
            <ButtonPrevious onClick={this._handleClickPrevious}>
              <IconFormArrowLeft />
            </ButtonPrevious>
            <Pagination
              currentSlide={currentSlideIndex}
              slideCount={this.state.slides.length}
              handleClickSlideChange={this._handleClickSlideChange}
            />
          </>
        )}
        <EnhancedSwipeableViews
          enableMouseEvents={this.props.mouseevents}
          slideRenderer={this._slideRenderer}
          interval={this.props.interval}
          autoplay={this.state.autoplay}
          onChangeIndex={this._handleIndexChange}
          index={this.state.index}
        />
      </CarouselWrapper>
    )
  }
}

ContentBrandHeroCarousel.defaultProps = {
  mouseevents: false,
  slides: [],
  autoplay: true,
  interval: 10000,
  index: 0,
  controls: true
}
ContentBrandHeroCarousel.propTypes = {
  slides: array,
  mouseevents: bool,
  interval: number,
  autoplay: bool,
  index: number,
  controls: bool
}

export default ContentBrandHeroCarousel
